import React, { Component } from "react";
import { Grid, Row, Col, 
    ButtonToolbar,
    FormControl, ControlLabel, InputGroup, FormGroup,
    ListGroup, ListGroupItem
} from "react-bootstrap";

import Button from "components/CustomButton/CustomButton.jsx";

import { auth, db } from "firedb/firebase";

import { Card } from "components/Card/Card.jsx";
import { throws } from "assert";

class Pushes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            phone : "",
            message : "",
            PushTestDisabled: false,
            PushDisabled:false,
            PhoneValid : null,
            PushValid : null,

            Company: null,
            PushList: {},
        };

        this.onClickPushTesting = this.onClickPushTesting.bind(this);
        this.onClickPush = this.onClickPush.bind(this);
        this.onChangePhone = this.onChangePhone.bind(this);
        this.onChangeMessage = this.onChangeMessage.bind(this);
    }

    componentWillMount() {
        db.ref('admin/' + auth.currentUser.uid).once('value')
            .then(snapshot => {
                this.setState({Company : snapshot.val().company});
                console.log("Company:");
                console.log(snapshot.val().company);

                return db.ref('notification/' + this.state.Company).once('value');
            })
            .then(snapshot => {
                console.log(snapshot.val());
                return this.setState({PushList : snapshot.val()})
            })
            .catch(err => {
                console.log("push list error");
                console.log(err);
            })
    }

    onChangePhone(event) {
        this.setState({
            phone : event.target.value,
            PushTestDisabled: false
        });
    }

    onChangeMessage(event) {
        this.setState({
            PushValid : null,
            message : event.target.value,
            PushTestDisabled: false
        });
    }

    onClickPush = (event) => {
        var phoneSplit = this.state.phone.split("+");
        var phone = phoneSplit[phoneSplit.length - 1];

        this.setState({
            PushDisabled : true
        })

        fetch('https://api.nakopi.club/push_notification', {
                'method': 'POST',
                'headers': {
                    'Content-Type': 'application/json'
                },
                'body': JSON.stringify({
                    'phone': phone,
                    'user': auth.currentUser.uid,
                    'message': this.state.message,
                })
            }).then(response => {
                if(response.status === 200) {
                    this.setState({
                        PushValid : "success"
                    });
                    var t = Date.now();
                    var pl = this.state.PushList;
                    pl[t] = {
                        message     : this.state.message,
                        timestamp   : t,
                        new         : true,
                    }

                    this.setState({PushList : pl});

                    // console.log("new push list : ");
                    // console.log(this.state.PushList);
                } else {
                    this.setState({
                        PhoneValid : "error",
                    });
                }
                console.log(response);
            }).catch(error => {
                this.setState({
                    PhoneValid : "error"
                });
                console.error(error);
            })
    }

    onClickPushTesting = (event) => {
        var phoneSplit = this.state.phone.split("+");
        var phone = phoneSplit[phoneSplit.length - 1];

        this.setState({
            PushTestDisabled : true
        })

        fetch('https://api.nakopi.club/push_testing', {
                'method': 'POST',
                'headers': {
                    'Content-Type': 'application/json'
                },
                'body': JSON.stringify({
                    'phone': phone,
                    'user': auth.currentUser.uid,
                    'message': this.state.message,
                })
            }).then(response => {
                if(response.status === 200) {
                    this.setState({
                        PhoneValid : "success",
                        // PushTestDisabled: true
                    });
                } else {
                    this.setState({
                        PhoneValid : "error",
                        // PushTestDisabled: true
                    });
                }
                console.log(response);
            }).catch(error => {
                this.setState({
                    PhoneValid : "error",
                    PushTestDisabled: false
                });
                console.error(error);
            })
    }

    render() {
        // var pushes = Object.values(this.state.PushList);
        var pushes = [];
        for(var i in this.state.PushList) {
            var time = new Date("02/10/2016");
            time.setTime(this.state.PushList[i].timestamp);

            pushes.push({
                timestamp : this.state.PushList[i].timestamp,
                message : time.getDay() + "/" + (time.getMonth() + 1) + "/" + time.getFullYear() + '    ' + this.state.PushList[i].message,
            });
        }

        console.log("render : ");
        console.log(pushes);

        pushes.sort(function(a, b) {
            if(a.timestamp < b.timestamp) {
                return 1;
            } 
            return -1;
        })

        const listItems = pushes.map((item) =>
            <ListGroupItem href='home#/notification'>{item.message}</ListGroupItem>
        );
    
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title="Создание оповещения"
                                content={
                                    <div>
                                        <Row>
                                            <Col xs={12}>
                                                <FormGroup validationState={this.state.PushValid}>
                                                    <ControlLabel>Сообщение</ControlLabel>
                                                    <FormControl
                                                        rows="4"
                                                        componentClass="textarea"
                                                        type="text"
                                                        bsClass="form-control"
                                                        placeholder="Текст Вашей расслыки"

                                                        onChange={this.onChangeMessage}
                                                        />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col>
                                                <div className="col-xs-12 col-sm-8 text-muted">
                                                    <br /><small>Вы можете посмотреть как будет выглядеть уведомление на своем телефоне.</small>
                                                    <br /><small>Для этого введите в это поле номер своего телефона и нажмите кнопку "Тестировать"</small>
                                                    <br /><small>Уведомление придет только на этот телефон.</small>
                                                    <br /><small>Убедитесь, что на телефоне установлено клиентское приложение Накопи!</small>
                                                    <br /><small></small>
                                                </div>
                                            </Col>
                                            <Col xs={6} sm={4}>
                                                <FormGroup validationState={this.state.PhoneValid} >
                                                    <ControlLabel>Телефон</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        bsClass="form-control"
                                                        placeholder="+79045506686"

                                                        onChange={this.onChangePhone}
                                                    />
                                                </FormGroup>
                                                <Button bsStyle="info" fill type="submit" 
                                                    data-toggle="tooltip" 
                                                    title="Уведомление будет отправленно только аккаунту с указанным телефоном"

                                                    disabled={this.state.PushTestDisabled}
                                                
                                                    onClick={this.onClickPushTesting}
                                                >
                                                    Тестировать
                                                </Button>
                                            </Col>                                                                                   
                                        </Row>                                         
            
                                        <Row>
                                            <Col xs={8} sm={6} style={{ "margin-top": 15}}>
                                                <Button bsStyle="danger btn-lg btn-block" pullRight fill type="submit" 
                                                    data-toggle="tooltip" data-placement="right" 
                                                    title="После нажатия уведомление будет отправлено всем Вашим клиентам"
                                                    disabled={this.state.PushDisabled}

                                                    onClick={this.onClickPush}
                                                >
                                                    Разослать всем клиентам
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            />
                        </Col>
             
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Card 
                                title="Выполнено:"
                                content={
                                    <ListGroup>
                                        {listItems}
                                    </ListGroup>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        
        );
    }
}

export default Pushes;



// WEBPACK FOOTER //
// ./src/views/Pushes/Pushes.jsx